<script>
  import { onMount } from 'svelte';

  import {
    createConfig, configureChains, connect as wagmiConnect, disconnect as wagmiDisconnect, getNetwork
  } from '@wagmi/core';
  import {
    mainnet, sepolia, goerli, dogechain, gnosis, gnosisChiado, polygon, polygonMumbai
  } from '@wagmi/core/chains';
  import { publicProvider } from '@wagmi/core/providers/public';
  import { alchemyProvider } from '@wagmi/core/providers/alchemy';
  import { infuraProvider } from '@wagmi/core/providers/infura';
  import { InjectedConnector } from '@wagmi/core/connectors/injected';
  import { MetaMaskConnector } from '@wagmi/core/connectors/metaMask';
  import { WalletConnectConnector } from '@wagmi/core/connectors/walletConnect';

  import { connection, walletName } from '../stores.js';

  import MetamaskIcon from './icons/metamask.svelte';
  import WalletconnectIcon from './icons/walletconnect.svelte';
  import BraveIcon from './icons/brave.svelte';

  export let apiKeys;

  let injectedWallet;

  let providers = [ publicProvider() ]
  if (apiKeys) {
    for (const [provider, keys] of Object.entries(apiKeys)) {
      for (const key of keys) {
        if (provider === 'infura') {
          providers.push(infuraProvider({ apiKey: key }));
        } else if (provider === 'alchemy') {
          providers.push(alchemyProvider({ apiKey: key }));
        }
      }
    }
  }

  const { chains, publicClient } = configureChains(
    [ mainnet, sepolia, goerli, dogechain, gnosis, gnosisChiado, polygon, polygonMumbai ], providers
  )

  const connectors = [ new InjectedConnector({ chains }), new MetaMaskConnector({ chains }) ];
  if (apiKeys && apiKeys.walletConnect) {
    connectors.push(
      new WalletConnectConnector({ chains, options: { projectId: apiKeys.walletConnect } })
    );
  }
  const config = createConfig({ connectors, publicClient });

  const connect = async connector => {
    const conn = await wagmiConnect({ connector: config.connectors[connector] });
    conn.chain = getNetwork();
    $connection = conn;
  }

  const disconnect = async () => {
    await wagmiDisconnect();
    $connection = undefined;
  }

  onMount(async () => {
    if(localStorage.getItem('wagmi.connected')) {
      const w = JSON.parse(localStorage.getItem('wagmi.wallet'));
      if (w === 'metaMask') await connect(1);
      else if (w === 'walletConnect') await connect(2);
      else await connect(0);
    }
    if (window.ethereum) {
      if (window.ethereum.isBraveWallet) {
        injectedWallet = 'Brave';
      } else if (window.ethereum.isMetaMask) {
        injectedWallet = 'Metamask';
      }
    }
  })
</script>

{#if injectedWallet}
  {#if $connection}
    <button class="lt-disconnect" on:click={ disconnect }>
      <slot>
        {#if $walletName === 'WalletConnect'}
          <WalletconnectIcon />
        {:else if $walletName === 'MetaMask'}
          <MetamaskIcon />
        {/if}
      </slot>
    </button>
  {:else}
    <div class="lt-connect">
      <span>Connect</span>
      {#if injectedWallet === 'Metamask'}
        <button class="metamask" on:click={ () => { connect(1) } }><MetamaskIcon /></button>
      {:else if injectedWallet === 'Brave'}
        <button class="brave" on:click={ () => { connect(0) } }><BraveIcon /></button>
      {/if}
      <button class="walletconnect" on:click={ () => { connect(2) } }><WalletconnectIcon /></button>
    </div>
  {/if}
{:else}
  Loading...
{/if}
